module.exports = __webpack_public_path__ + "static/img/mission.0281b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/mission.png
// module id = /lKE
// module chunks = 0